<template>
    <div>
        <el-form ref="form" :model="value" :rules="rules">
            <!-- <div class="two-lines"> -->
            <template v-for="(item,idx) in config">
                <!-- <slot v-if="item.slot" :name="item.slot" v-bind:item="item"></slot> -->
                <el-form-item v-if="!item.slot" class="lines" :key="item.zdname" :label="item.label"
                    :prop="item.zdname" :label-width="item.labelWidth ? item.labelWidth : ''"
                    size="mini">
                    <el-input :readonly="!isEidt || item.readonly || cusConfig[idx].readonly"
                        v-if="item.kjlx == 'input' || !item.kjlx" class="my_inp"
                        v-model="value[item.zdname]" :placeholder="'请输入' + item.label" clearable>
                        <template slot="append">
                            <el-button v-if="isEidt && item.type" @click="openTypePage(item)"
                                type="primary">
                                {{ item.btnLab || "选择" }}
                            </el-button>
                        </template>
                    </el-input>
                    <el-radio-group style="width: 100%" v-if="item.kjlx == 'radio'"
                        v-model="value[item.zdname]">
                        <el-radio v-for="(item2, index2) in item.list" :key="index2"
                            :label="item2.value">{{ item2.lab }}</el-radio>
                    </el-radio-group>
                    <el-input v-if="item.kjlx == 'number'" class="my_inp" type="number"
                        v-model.number="value[item.zdname]" :placeholder="'请输入' + item.label">
                    </el-input>
                    <FileUpload v-if="item.kjlx == 'files'" v-model="value[item.zdname]"
                        style="width: 100%" isBtn></FileUpload>
                    <el-select v-if="item.kjlx == 'select'" v-model="value[item.zdname]"
                        :placeholder="'请输入' + item.label" class="my_inp" clearable>
                        <el-option v-for="item2 in item.list" :value="item2.value"
                            :label="item2.lab"></el-option>
                    </el-select>
                    <el-date-picker v-if="item.kjlx == 'date'" v-model="item.value"
                        :placeholder="'请选择' + item.label" value-format="yyyy-MM-dd" class="my_inp"
                        type="date" @change="changeRange($event, item)">
                    </el-date-picker>
                    <el-date-picker v-if="item.kjlx == 'daterange'" v-model="value[item.zdname]"
                        :placeholder="'请选择' + item.label" value-format="yyyy-MM-dd" class="my_inp"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        type="daterange" @change="changeRange($event, item)">
                    </el-date-picker>
                    <el-date-picker v-if="item.kjlx == 'datetime'" v-model="value[item.zdname]"
                        :placeholder="'请选择' + item.label" value-format="yyyy-MM-dd HH:mm:ss"
                        class="my_inp" type="datetime" @change="changeRange($event, item)">
                    </el-date-picker>
                    <el-date-picker v-if="item.kjlx == 'datetimerange'" v-model="value[item.zdname]"
                        :placeholder="'请选择' + item.label" value-format="yyyy-MM-dd HH:mm:ss"
                        class="my_inp" range-separator="至" start-placeholder="开始时间"
                        end-placeholder="结束时间" type="datetimerange"
                        @change="changeRange($event, item)">
                    </el-date-picker>
                </el-form-item>
            </template>
            <!-- <el-form-item v-if="config.length % 2 == 1" class="lines">
                </el-form-item> -->
            <!-- </div> -->
        </el-form>
        <vxe-modal v-model="typeData.visibled" :fullscreen="false" width="90vw" height="90vh"
            min-width="800" min-height="600" show-zoom resize :transfer="true"
            :destroy-on-close="true" :title="typeData.title" :className="'cus-model-bg'">
            <component :is="typeData.name" @handle="typeHandle" @handle1="handle1" />
        </vxe-modal>
    </div>
</template>
<script>


export default {
  name: "SearchList",
  props: {
    config: { type: Array, default: () => [] },
    value: { type: Object, default: () => { } },
    isEidt: {
      type: Boolean,
      default: true,
    },
  },
  components: {

  },
  model: {
    event: "change",
  },
  watch: {
    config: {
      handler: function (val) {
        this.cusConfig = JSON.parse(JSON.stringify(val))
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.initParams = {
      ...this.value,
    };
    var rules = {},
      obj = {};
    this.config.forEach((item) => {
      if (item.require) {
        obj = {
          required: true,
          message: `请输入${item.label}`,
        };
        if (item.kjlx == "number") {
          obj.type = "number";
        }
        rules[item.zdname] = [obj];
      }
      if (item.value == "#NOW#") {
        switch (item.kjlx) {
          case "datetime":
            if (this.initParams[item.zdname] + "" !== "undefined") {
              this.initParams[item.zdname] = new Date().format("yyyy-MM-dd hh:mm:ss")
            }
            break;
        }
      } else if (item.value) {
        if (this.initParams[item.zdname] + "" !== "undefined") {
          this.initParams[item.zdname] = item.value
        }
      }

      //   if (item.fun) {
      //     console.log(typeof this.$parent[item.fun])
      //   }
      //  && typeof this.$parent[item.fun] == "function"
      if (item.fun) {//&& typeof this.$parent[item.fun] == "function"


        this.$emit("fun", {
          funName: item.fun,
          res: {
            value: this.initParams,
            item,
          }
        })
      }
    });
    // console.log(this.$parent)
    this.$emit("change", this.initParams);
    this.$emit("on-change", this.initParams);
    this.rules = rules;
  },
  mounted() {
    // console.log(typeof this.$parent.setTestDate)

  },

  data() {
    return {
      initParams: {},
      cusConfig: [],
      rules: {},
      typeData: {
        visibled: false,
        name: "",
        data: {},
      },
      cliItem: {},
    };
  },
  methods: {
    getResult(handle) {
      this.$refs.form.validate((valid) => {
        // if()
        handle(valid ? this.value : valid);
      });
    },
    openTypePage(item) {
      if (item.type == "providerName") {
        this.cliItem = item;
        this.typeData.title = "选择供应商";
        this.typeData.name = "provider";
        this.typeData.visibled = true;
      } else if (item.type == "provider2Name") {
        this.cliItem = item;
        this.typeData.title = "留样样品记录";
        this.typeData.name = "provider2";
        this.typeData.visibled = true;
      } else if (item.type == "contractCode") {
        this.cliItem = item;
        this.typeData.title = "选择合同";
        this.typeData.name = "contractPage";
        this.typeData.visibled = true;
      }
    },
    typeHandle(obj) {
      console.log(obj)
      if (this.cliItem.type == "providerName") {
        var forms = {
          ...this.value,
        };
        forms.providerName = obj.providerName;
        forms.providerId = obj.id;
        this.$emit("change", forms);
        this.$emit("on-change", forms);

      } else if (this.cliItem.type == "provider2Name") {//留样样品记录
        var forms = {
          ...this.value,
          ...obj,
          lyType: 2//关联留样
        };
        this.cusConfig.forEach(item => {
          if (item.type == "provider2Name") {
            item.readonly = true;
          }
        })
        // this.cliItem.readonly = true;
        this.$emit("change", forms);
        this.$emit("on-change", forms);
      } else if (this.cliItem.type == "contractCode") {
        var forms = {
          ...this.value,
          contractId: obj.id,
          contractCode: obj.contractCode,
          providerId: obj.providerId,
          providerName: obj.providerName,
          materialIds: obj.materialIds

        };
        this.$emit("change", forms);
        this.$emit("on-change", forms);
      }


      this.typeData.visibled = false;
    },
    handle1(testBlockCode) {
      //   this.$emit("choose", testBlockCode);
      //   this.typeData.visibled = false;
    },

    changeRange(val, item) {
      //   console.log(this.$parent)
      //   if (item.fun) {
      //     console.log(typeof this.$parent[item.fun] == "function")
      //   }
      if (item.fun) {//&& typeof this.$parent[item.fun] == "function"
        // debugger
        var res = {
          value: this.value,
          val,
          item
        }
        this.$emit("fun", {
          funName: item.fun,
          res
        })
      }
    },
    resetQuery() {
      var obj = {
        ...this.initParams,
      };
      this.$emit("change", obj);
      this.$emit("on-change", obj);
    },
    query() {
      var obj = {
        ...this.value,
        pageIndex: 1,
      };
      this.$emit("change", obj);
      this.$emit("on-change", obj);
    },

  }
};
</script>
<style lang="scss" scoped>
.two-lines {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  .lines {
    flex: 0 0 45%;
    display: inline-flex;
  }
  .my_inp {
    width: 100%;
    flex: 1 0 auto;
  }
}
</style>
